import { AxiosError, isAxiosError } from "axios";

type ShouldRetryFunction = (failureCount: number, error: AxiosError) => boolean;

export const DO_NOT_RETRY_ON_404: ShouldRetryFunction = (
  failureCount,
  error,
) => {
  return error.response?.status !== 404 && failureCount < 3;
};

/**
 * The HTTP status behind a React Query error, or `undefined` when the request
 * never got a response (network failure, CORS, abort). Callers must treat
 * `undefined` as "unknown failure" rather than folding it into a specific
 * status, since the two are not distinguishable to the user otherwise.
 */
export const getResponseStatus = (error: unknown): number | undefined =>
  isAxiosError(error) ? error.response?.status : undefined;
